import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import ModifyFormSchedule from '../../components/forms/schedule/form.schedule';

function EditSchedules() {
  const {id} = useParams();
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type:''
  });


  const upsertSchedule = ({message , type}) => {
    setAlert({ show: true, message , type });
  };

  useEffect(() => {}, [id]);
  return (
    <Base>
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModifyFormSchedule selectSchedule={id}  callback={upsertSchedule}></ModifyFormSchedule>
    </Base>
  );
}

export default EditSchedules;
